import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-02/lesson-30/task-02";

const task: Slide = {
  titleHtml:
    "Which musical instruments make use of the psychoacoustic effect of the missing fundamental<br>to create the illusion that lower pitched notes can be heard than the intrument can actually<br>physically produce?  Drag a line from point to point.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
